/*example of action creator syntax

export function setAppGlobals(request) {
    return {
        type: 'SET_APP_GLOBALS',
        payload: request,
    };
}
*/

//Application URL Params

export function setPathname(pathname) {
    return {
        type: 'SET_PATH_NAME',
        payload: pathname,
    };
}
export function setBrand(brand) {
    return {
        type: 'SET_BRAND',
        payload: brand,
    };
}

export function setServer(server) {
    return {
        type: 'SET_SERVER',
        payload: server,
    };
}

// Year Make Model Reducer
export function setYears(years) {
    return {
        type: 'SET_YEARS',
        payload: years,
    };
}

export function setMakes(makes) {
    return {
        type: 'SET_MAKES',
        payload: makes,
    };
}

export function setModels(models) {
    return {
        type: 'SET_MODELS',
        payload: models,
    };
}

export function setTrims(trims) {
    return {
        type: 'SET_TRIMS',
        payload: trims,
    };
}

export function setSizes(sizes) {
    return {
        type: 'SET_SIZES',
        payload: sizes,
    };
}

export function setZipCode(zipcode) {
    return {
        type: 'SET_ZIPCODE',
        payload: zipcode,
    };
}

export function setSelectYear(year) {
    return {
        type: 'SET_SELECT_YEAR',
        payload: year,
    };
}

export function setSelectMake(make) {
    return {
        type: 'SET_SELECT_MAKE',
        payload: make,
    };
}

export function setSelectModel(model) {
    return {
        type: 'SET_SELECT_MODEL',
        payload: model,
    };
}
export function setSelectTrim(trim) {
    return {
        type: 'SET_SELECT_TRIM',
        payload: trim,
    };
}

export function setSelectSize(size) {
    return {
        type: 'SET_SELECT_SIZE',
        payload: size,
    };
}

export function setDealerFlag(boolean) {
    return {
        type: 'SET_DEALER_FLAG',
        payload: {
            dealerFlag: boolean
        }
    }
}

export function setDealers(dealers) {
    return {
        type: 'SET_DEALERS',
        payload: dealers,
    };
}

export function setDealerServices(services) {
    return {
        type: 'SET_DEALER_SERVICES',
        payload: services,
    };
}

export function setCurrentLatLng(position) {
    return {
        type: 'SET_CURRENT_LAT_LNG',
        payload: position,
    };
}

export function setInstallation(index) {
    return {
        type: 'SET_INSTALLATION',
        payload: index,
    };
}

export function setAdditionalServices(index) {
    return {
        type: 'SET_ADDITIONAL_SERVICES',
        payload: index,
    };
}
export function newTire(boolean) {
    return {
        type: 'NEW_TIRE',
        payload: boolean,
    };
}
export function updateResults(boolean) {
    return {
        type: 'UPDATE_RESULTS',
        payload: boolean,
    };
}
export function setClearCheckboxSnackbar(boolean) {
    return {
        type: 'SET_CLEAR_CHECKBOX_SNACKBAR',
        payload: boolean,
    };
}
export function setBrandsList(result) {
    return {
        type: 'SET_BRANDS_LIST',
        payload: result,
    };
}
export function setSpeedRatingList(result) {
    return {
        type: 'SET_SPEED_RATING_LIST',
        payload: result,
    };
}
export function setLoadsList(result) {
    return {
        type: 'SET_LOADS_LIST',
        payload: result,
    };
}
export function setTireTypesList(result) {
    return {
        type: 'SET_TIRE_TYPES_LIST',
        payload: result,
    };
}
export function setClassificationList(result) {
    return {
        type: 'SET_CLASSIFICATION',
        payload: result,
    };
}
export function updateFilters(boolean) {
    return {
        type: 'UPDATE_FILTERS',
        payload: boolean,
    };
}
export function setFilterDialogFlag(boolean) {
    return {
        type: 'SET_FILTER_DIALOG_FLAG',
        payload: boolean,
    };
}
export function setTireSizeDialogFlag(boolean) {
    return {
        type: 'SET_TIRE_SIZE_DIALOG_FLAG',
        payload: boolean,
    };
}
export function setSearchTerm(result) {
    return {
        type: 'SET_SEARCH_TERM',
        payload: {
            searchTerm: result
        },
    };
}
export function setSortValue(result) {
    return {
        type: 'SET_SORT_VALUE',
        payload: {
            searchTerm: result
        },
    };
}
export function setServiceOptions(services) {
    return {
        type: 'SET_SERVICE_OPTIONS',
        payload: services,
    };
}

export function clearCurrentLatLng() {
    return {
        type: 'CLEAR_CURRENT_LAT_LNG',
        payload: {
            position: null
        },
    }
}

export function setSpinner(val) {
    return {
        type: 'SET_SPINNER',
        payload: val,
    };
}

export function setHeaderTitle(location) {
    return {
        type: 'SET_HEADER_FOOTER',
        payload: location,
    };
}
export function setAppConfig(config) {
    return {
        type: 'SET_APPCONFIG',
        payload: config,
    };
}

// search results reducer
export function setBAC(bac) {
    return {
        type: 'SET_BAC',
        payload: bac,
    };
}

export function setSearchResult(result) {
    return {
        type: 'SET_SEARCH_RESULT',
        payload: result,
    };
}

export function setOriginalEquipment(result) {
    return {
        type: 'SET_ORIGINAL_EQUIPMENT',
        payload: result,
    };
}

export function setSearchResultBrand(result) {
    return {
        type: 'SET_SEARCH_RESULT_BRAND',
        payload: result,
    };
}

export function setSearchSort(result) {
    return {
        type: 'SET_SEARCH_SORT',
        payload: result,
    };
}

export function setFilteredResult(result) {
    return {
        type: 'SET_FILTERED_RESULT',
        payload: result,
    };
}

export function incrementSearchQuantity(result) {
    return {
        type: 'INCREMENT_SEARCH_QUANTITY',
        payload: result
    };
}

export function decrementSearchQuantity(result) {
    return {
        type: 'DECREMENT_SEARCH_QUANTITY',
        payload: result
    }
}

export function setSearchQuantity(result) {
    return {
        type: 'SET_SEARCH_QUANTITY',
        payload: result
    }
}

export function resetSearchQuantities() {
    return {
        type: 'RESET_SEARCH_QUANTITIES',
        payload: true
    }
}

export function setIndex(gmPartNum) {
    return {
        type: 'SET_INDEX',
        payload: gmPartNum
    }
}

export function setResultsFlag(boolean) {
    return {
        type: 'SET_RESULTS_FLAG',
        payload: {
            resultsFlag: boolean
        }
    }
}


// cart reducer
export function addTire(cartItem) {
    return {
        type: 'ADD_TIRE',
        payload: cartItem,
    }
}

export function reCalculate(boolean) {
    return {
        type: 'RECALCULATE',
        payload: boolean,
    };
}

export function addTireQuantity(cartItem) {
    return {
        type: 'ADD_TIRE_QUANTITY',
        payload: cartItem,
    }
}

export function incrementCartQuantity(result) {
    return {
        type: 'INCREMENT_CART_QUANTITY',
        payload: result
    };
}

export function decrementCartQuantity(result) {
    return {
        type: 'DECREMENT_CART_QUANTITY',
        payload: result
    }
}

export function removeTire(cartItem) {
    return {
        type: 'REMOVE_TIRE',
        payload: cartItem,
    }
}

export function setDealerEnrollment(status) {
    return {
        type: 'SET_DEALER_ENROLLMENT',
        payload: status
    }
}

export function selectDealer(dealer) {
    return {
        type: 'SELECT_DEALER',
        payload: dealer
    }
}

export function setReduxMarkers(markers) {
    return {
        type: 'SET_REDUX_MARKERS',
        payload: markers
    }
}

export function addReduxMarker(markerID, marker) {
    return {
        type: 'ADD_REDUX_MARKER',
        payload: {
            markerID: markerID,
            marker: marker
        }
    }
}

export function setBlob(blob) {
    return {
        type: 'SET_BLOB',
        payload: {
            blobOfCart: blob
        }
    }
}

export function addCheckboxTire(gmPartNum) {
    return {
        type: 'ADD_CHECKBOX_TIRE',
        payload: {
            gmPartNum: gmPartNum
        }
    }
}

export function removeCheckboxTire(gmPartNum) {
    return {
        type: 'REMOVE_CHECKBOX_TIRE',
        payload: {
            gmPartNum: gmPartNum
        }
    }
}

export function clearCheckboxTires(boolean) {
    return {
        type: 'CLEAR_CHECKBOX_TIRES',
        payload: boolean
    }
}

export function setGoogleMapsLookupError(error) {
    return {
        type: 'SET_GOOGLE_MAPS_LOOKUP_ERROR',
        payload: {
            googleMapsError: error
        }
    }
}

export function setDealerLocatorRenderFlag(boolean) {
    return {
        type: 'SET_DEALER_LOCATOR_RENDER_FLAG',
        payload: {
            renderFlag: boolean
        }
    }
}

export function setAdobeReadyFlag(boolean) {
    return {
        type: 'SET_ADOBE_READY_FLAG',
        payload: {
            flag: boolean
        }
    }
}

export function toggleOffFirstLoad() {
    return {
        type: 'TOGGLE_OFF_FIRST_LOAD',
        payload: {}
    }
}

export function setDealerServicesFlag(boolean) {
    return {
        type: 'SET_DEALER_SERVICES_FLAG',
        payload: {
            flag: boolean
        }
    }
}

export function clearCart() {
    return {
        type: 'CLEAR_CART',
        payload: {}
    }
}

export function setAxiosCancelSource(source) {
    return {
        type: 'SET_AXIOS_CANCEL_SOURCE',
        payload: {
            axiosCancelSource: source
        }
    }
}
